var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilters20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arved",
    transform: "translate(-14.000000, -188.000000)",
    stroke: "#F0B423",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4285714,38 L28.4285714,30.173913 C28.4285714,28.5217391 29.2857143,27 30.7142857,26 L35.5238095,22.3043478 L36,18 L16,18 L16.4761905,22.4347826 L21.2380952,26 C22.6666667,27 23.5238095,28.5217391 23.5714286,30.173913 L23.5714286,35.826087 L28.4285714,38 Z",
    id: "Stroke-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilters20Px);
export default __webpack_public_path__ + "static/media/Icon_Filters-20px.3670c6695689a796e7b30f63840b7436.svg";
export { ForwardRef as ReactComponent };